import DividerBase from './DividerBase';

export const Divider = DividerBase;

export default {
  Divider,
};
